import { Component, Input, OnInit } from "@angular/core";
import * as Highcharts from "highcharts";
import { cloneDeep } from "lodash";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "horizontal-bar",
  templateUrl: "./horizontal-bar.component.html",
  styleUrls: ["./horizontal-bar.component.scss"],
})
export class HorizontalBarComponent implements OnInit {
  options: Object;
  toolTipText: string;
  chart;
  Highcharts = Highcharts;
  @Input()
  chartData;
  @Input()
  goal;
  @Input()
  goalText;
  @Input()
  min;
  @Input()
  max;
  @Input()
  dataSuffix;
  @Input()
  dataPrefix;
  @Input()
  level;
  @Input()
  roundTo;
  @Input()
  overall;
  @Input()
  domainId;
  @Input()
  selectedCategory;
  @Input()
  entityId;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.createChart();
  }

  createChart() {
    var self = this;
    this.options = {
      chart: {
        type: "bar",
        marginRight: 25,
      },
      title: {
        text: null,
      },
      xAxis: {
        type: "category",
        labels: {
          style: {
            lineSpacing: "0.5rem",
          },
        },
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        lineColor: "transparent",
        minorTickLength: 0,
        tickLength: 0,
      },
      yAxis: {
        min: this.min < 0 ? this.min : 0,
        max: this.max < 0 ? 0 : this.max,
        gridLineWidth: 0,
        labels: {
          enabled: false,
        },
        title: {
          text: null,
        },
        plotLines:
          this.goal != null
            ? [
                {
                  color: "#878787",
                  dashStyle: "dash",
                  value: this.goal,
                  width: 1.5,
                  zIndex: 4,
                  label: {
                    text:
                      this.goalText +
                      (this.level == "school" ? " SCHOOL GOAL" : " GOAL"),
                    rotation: 0,
                    align: "center",
                    style: {
                      fontSize: "1.1rem",
                      fontFamily: "'Lato', Helvetica, sans-serif",
                      color: "#6E6E6E",
                    },
                    y: -0.7,
                    x: -1,
                  },
                },
              ]
            : [],
      },
      legend: {
        enabled: false,
      },
      credits: false,
      plotOptions: {
        series: {
          cursor: "pointer",
          point: {
            events: {
              click: function () {
                self.redirectToOurStudents(this.category);
              },
            },
          },
          dataLabels: {
            enabled: true,
            crop: false,
            overflow: "none",
            color: "#6E6E6E",
            style: {
              fontSize: "1.1rem",
              fontFamily: "'Lato', Helvetica, sans-serif",
              textShadow: "none",
              textRendering: "optimizeLegibility",
            },
            format: this.dataPrefix + "{point.y:,.f}" + this.dataSuffix,
          },
        },
      },
      series: [
        {
          data: this.chartData.data,
        },
      ],
      tooltip: {
        shared: false,
        useHTML: true,
        borderColor: "#aaa",
        backgroundColor: "rgba(255,255,255,1)",
        shadow: false,
        headerFormat: "",
        style: {
          fontFamily: "'Lato', Helvetica, sans-serif",
          backgroundColor: "#FFFFFF",
        },
        formatter: function () {
          if (self.dataSuffix === "") {
            self.toolTipText = `${self.dataPrefix || ""}<strong>
                ${
                  this.point.numerator != null
                    ? this.point.numerator.toLocaleString()
                    : ""
                }</strong> ${this.point.descriptor}`;
          } else {
            self.toolTipText = `${self.dataPrefix || ""}<strong>
                ${
                  this.point.numerator != null
                    ? this.point.numerator.toLocaleString()
                    : ""
                }</strong>
                 of ${self.dataPrefix || ""}<strong>${
              this.point.denominator != null
                ? this.point.denominator.toLocaleString()
                : ""
            } ${this.point.descriptor}`;
          }
          // check for roundTo=0/non-1005 domain and show percent of total
          if (self.roundTo == 0 && self.domainId != "1005") {
            self.toolTipText =
              self.toolTipText +
              ` ${
                this.point.numerator != null && self.overall != null
                  ? `(${(
                      100 *
                      (parseFloat(this.point.numerator) /
                        parseFloat(self.overall))
                    ).toFixed(1)}%)`
                  : ""
              }`;
          }
          return `<div>
                        <span class="metric-tooltip title capitalize tile_body">
                            ${this.point.name}
                        </span>
                        <span class="metric-tooltip value tooltip_value" style="color: ${
                          this.point.color
                        }">
                            ${self.dataPrefix} ${
            this.point.y != null
              ? this.point.y.toLocaleString(undefined, {
                  minimumFractionDigits: self.roundTo,
                  maximumFractionDigits: self.roundTo,
                })
              : ""
          } ${self.dataSuffix}
                        </span>
                      </div>
                      <div class="metric-tooltip description body_tooltip_text">
                        ${self.toolTipText} 
                      </div>`;
        },
      },
    };
  }

  chartCallback = (chart) => {
    this.chart = chart;

    //KPI-9385 - Added call to the force the chart to resize itself after a digest cycle.  This is needed in cases when the renderTo
    //container changes size, but the chart has already set its size.
    setTimeout(() => {
      if (chart.chartHeight !== chart.renderTo.clientHeight) {
        chart.setSize(undefined, null, true);
      }
    });
  };

  ngOnChanges(changes) {
    this.chartData = cloneDeep(this.chartData);
    if (this.chart) {
      this.createChart();
    }
  }

  redirectToOurStudents(categoryId) {
    const categoryValue =
      this.chartData && this.chartData.data && this.chartData.data[categoryId]
        ? this.chartData.data[categoryId].name
        : "";
    let queryParams = { ...this.route.snapshot.queryParams };
    queryParams = {
      ...queryParams,
      demographicFilterKey: this.selectedCategory,
      demographicFilterValues: categoryValue,
    };
    if (this.level === "school" && this.entityId) {
      queryParams = {
        ...queryParams,
        schoolId: this.entityId,
      };
    }
    this.router.navigate(["/comparison/student"], {
      relativeTo: this.route,
      queryParams,
    });
  }
}
